module.exports = __webpack_public_path__ + "static/media/sawBigLogo.b67f07fd.png";